module.exports = __webpack_public_path__ + "media/images/icon-sensemaking-3f6f2368e531b9fe0ec3747bbe7e713a.svg";